<div class="n-oldalfej">
  <div>
    <h2>Bérfeladás</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} → {{ adat?.naplo?.nev || 'NAPLO' }} · {{ idoszakNev }}</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button fill="outline" (click)="nyomtat()" [disabled]="!adat?.tetel" title="A feladás könyvelési tételei főkönyvi számokkal, nyomtatva">
    <ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás
  </ion-button>
  <ion-button (click)="felad()" [disabled]="!adat?.feladhato || kuld" title="A bruttó bér és a közterhek feladása a NAPLO-ba">
    <ion-icon slot="start" name="git-network-outline"></ion-icon>Feladás a NAPLO-ba
  </ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId && adat">
  <div class="as-figyel" *ngIf="adat.hibak.length || adat.figyelmeztetesek.length">
    <span class="cimke piros" *ngFor="let h of adat.hibak">{{ h }}</span>
    <span class="cimke sarga" *ngFor="let f of adat.figyelmeztetesek">{{ f }}</span>
  </div>

  <!-- KETTŐS KÖNYVVITEL: a vegyes napló tétele T/K párokkal -->
  <ng-container *ngIf="adat.kettos && adat.tetel">
    <div class="ata-kpi as-kpi">
      <div class="n-panel ata-k"><span>A vegyes naplóba kerülő tétel</span><b>{{ adat.tetel.sorszam }}. tétel</b>
        <small>{{ adat.tetel.datum }} · bizonylat: {{ adat.tetel.bizonylatszam }}</small></div>
      <div class="n-panel ata-k"><span>Bruttó bér</span><b>{{ adat.osszesen.brutto | number:'1.0-0' }} Ft</b><small>{{ adat.osszesen.db }} számfejtés</small></div>
      <div class="n-panel ata-k"><span>Levonások</span><b>{{ (adat.osszesen.levonasok + adat.osszesen.letiltas + adat.osszesen.egyeb_levonas) | number:'1.0-0' }} Ft</b>
        <small>SZJA {{ adat.osszesen.szja | number:'1.0-0' }} · TB {{ adat.osszesen.tb | number:'1.0-0' }}<ng-container *ngIf="adat.osszesen.ekho"> · EKHO {{ adat.osszesen.ekho | number:'1.0-0' }}</ng-container></small></div>
      <div class="n-panel ata-k ata-teher"><span>{{ adat.osszesen.kiva ? 'KIVA' : 'Szocho' }}</span><b>{{ adat.osszesen.munkaltatoi | number:'1.0-0' }} Ft</b>
        <small>a {{ adat.fokonyv?.elszamolas }}-en marad a nettó: {{ adat.netto_marad | number:'1.0-0' }} Ft</small></div>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>#</th><th>Tartozik</th><th>Követel</th><th>Megnevezés</th><th class="num">Összeg</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of adat.parok; let i = index">
            <td>{{ i + 1 }}</td>
            <td><b>{{ p.tartozik.szamlaszam }}</b> <span class="n-alcim">{{ p.tartozik.nev || '— nincs a számlatükörben —' }}</span></td>
            <td><b>{{ p.kovetel.szamlaszam }}</b> <span class="n-alcim">{{ p.kovetel.nev || '— nincs a számlatükörben —' }}</span></td>
            <td>{{ p.megnevezes }}</td>
            <td class="num"><b>{{ p.osszeg | number:'1.0-0' }}</b></td>
          </tr>
        </tbody>
        <tfoot><tr><td colspan="4">Összesen (tartozik = követel)</td><td class="num">{{ parokOsszesen | number:'1.0-0' }}</td></tr></tfoot>
      </table>
    </div>
    <p class="as-leiras">Megnevezés a vegyes naplóban: „{{ adat.tetel.megjegyzes }}”. A nettó bér a {{ adat.fokonyv?.elszamolas }} számlán marad, a kifizetést a bankkivonat rendezi (T {{ adat.fokonyv?.elszamolas }} / K 384).</p>

    <div class="n-panel">
      <div class="n-panel-cim">Főkönyvi számok <span class="n-alcim">· {{ adat.naplo?.nev }} – üresen hagyva az alapértelmezés; a gyűjtőszámla helyett az első alszámlájára könyvel</span></div>
      <div class="bf-fk">
        <label *ngFor="let k of fkKulcsok">{{ adat.fokonyv_cimkek[k] }}
          <input [(ngModel)]="fk[k]" [placeholder]="adat.fokonyv_alap[k]" inputmode="numeric" maxlength="12">
        </label>
      </div>
      <button type="button" class="ov-gomb" (click)="fokonyvMent()" [disabled]="fkMent"><ion-icon name="save-outline"></ion-icon>Főkönyvi számok mentése</button>
    </div>
  </ng-container>

  <ng-container *ngIf="!adat.kettos && adat.tetel && adat.feladhato">
    <div class="ata-kpi as-kpi">
      <div class="n-panel ata-k"><span>A naplóba kerülő tétel</span><b>{{ adat.tetel.sorszam }}. tétel</b>
        <small>{{ adat.tetel.datum }} · bizonylat: {{ adat.tetel.bizonylatszam }} · {{ adat.tetel.penztar?.nev || 'pénztár nélkül' }}</small></div>
      <div class="n-panel ata-k"><span>Bruttó bér (4. oszlop)</span><b>{{ adat.osszesen.brutto | number:'1.0-0' }} Ft</b>
        <small>{{ adat.osszesen.db }} számfejtés</small></div>
      <div class="n-panel ata-k"><span>Közterhek (5. oszlop)</span><b>{{ (adat.osszesen.levonasok + adat.osszesen.munkaltatoi) | number:'1.0-0' }} Ft</b>
        <small>SZJA + TB {{ adat.osszesen.levonasok | number:'1.0-0' }} · {{ adat.osszesen.kiva ? 'KIVA' : 'szocho' }} {{ adat.osszesen.munkaltatoi | number:'1.0-0' }}</small></div>
      <div class="n-panel ata-k ata-teher"><span>Könyvelt összesen</span><b>{{ sorokOsszesen | number:'1.0-0' }} Ft</b>
        <small>{{ adat.naplo?.nev }} · {{ adat.naplo?.konyveles_mod === 'kettos' ? 'kettős' : 'egyszeres' }} könyvvitel</small></div>
    </div>

    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>#</th><th>Rovatszám</th><th>Rovat</th><th>Tétel</th><th class="num">Oszlop</th><th>Irány</th><th class="num">Összeg</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of adat.sorok">
            <td>{{ s.sorszam }}</td>
            <td><b>{{ s.rovatszam }}</b></td>
            <td>{{ s.rovat_nev }} <span class="cimke sarga as-uj" *ngIf="s.uj_rovat">új rovat jön létre</span></td>
            <td>{{ s.cim }}</td>
            <td class="num">{{ s.oszlop }}.</td>
            <td>kiadás</td>
            <td class="num"><b>{{ s.osszeg | number:'1.0-0' }}</b></td>
          </tr>
        </tbody>
        <tfoot *ngIf="adat.sorok.length"><tr><td colspan="6">Összesen</td><td class="num">{{ sorokOsszesen | number:'1.0-0' }}</td></tr></tfoot>
      </table>
      <div class="ures" *ngIf="!adat.sorok.length"><ion-icon name="git-network-outline"></ion-icon>Nincs feladható tétel.</div>
    </div>
    <p class="as-leiras" *ngIf="adat.tetel">Megjegyzés a naplóban: „{{ adat.tetel.megjegyzes }}”.</p>
  </ng-container>

  <div class="n-panel" *ngIf="adat.korabbi?.length">
    <div class="n-panel-cim">Korábbi feladások erre a hónapra</div>
    <div class="as-kv"><ng-container *ngFor="let k of adat.korabbi"><span>{{ k.sorszam }}. tétel · {{ k.datum | slice:0:10 }}</span><b>{{ k.megjegyzes }}</b></ng-container></div>
  </div>

  <div class="tabla-wrap" *ngIf="adat.reszletek.length">
    <table class="n-racs">
      <thead><tr><th>Dolgozó</th><th>Állapot</th><th class="num">Bruttó</th><th class="num cs-afa">SZJA</th><th class="num cs-penz">TB-járulék</th><th class="num" *ngIf="adat.osszesen.ekho">EKHO</th>
        <th class="num">{{ adat.osszesen.kiva ? 'KIVA' : 'Szocho' }}</th><th class="num">Nettó</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of adat.reszletek">
          <td><b>{{ r.alkalmazott_nev }}</b></td>
          <td><span class="cimke" [class.zold]="r.allapot === 'veglegesitett'" [class.sarga]="r.allapot !== 'veglegesitett'">{{ r.allapot === 'veglegesitett' ? 'véglegesített' : 'tervezet' }}</span></td>
          <td class="num">{{ r.brutto | number:'1.0-0' }}</td>
          <td class="num cs-afa">{{ r.szja | number:'1.0-0' }}</td>
          <td class="num cs-penz">{{ r.tb_jarulek | number:'1.0-0' }}</td>
          <td class="num" *ngIf="adat.osszesen.ekho">{{ r.ekho | number:'1.0-0' }}</td>
          <td class="num">{{ r.szocho | number:'1.0-0' }}</td>
          <td class="num">{{ r.netto | number:'1.0-0' }}</td>
        </tr>
      </tbody>
      <tfoot><tr>
        <td colspan="2">Összesen</td>
        <td class="num">{{ adat.osszesen.brutto | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ adat.osszesen.szja | number:'1.0-0' }}</td>
        <td class="num cs-penz">{{ adat.osszesen.tb | number:'1.0-0' }}</td>
        <td class="num" *ngIf="adat.osszesen.ekho">{{ adat.osszesen.ekho | number:'1.0-0' }}</td>
        <td class="num">{{ adat.osszesen.munkaltatoi | number:'1.0-0' }}</td>
        <td class="num">{{ adat.osszesen.netto | number:'1.0-0' }}</td>
      </tr></tfoot>
    </table>
  </div>

  <div class="n-panel as-info" *ngIf="adat.kettos">
    <ion-icon name="information-circle-outline"></ion-icon>
    <div>
      <p>Kettős könyvvitelnél a feladás egy tételt ír a NAPLO-ügyfél <b>vegyes naplójába</b>: T {{ adat.fokonyv?.ber_koltseg }} / K {{ adat.fokonyv?.elszamolas }} a bruttó bér,
        T {{ adat.fokonyv?.elszamolas }} / K {{ adat.fokonyv?.szja }}, {{ adat.fokonyv?.tb }} a levont SZJA és járulék, T {{ adat.fokonyv?.elszamolas }} / K {{ adat.fokonyv?.levonas }} a letiltás és az egyéb levonás,
        T {{ adat.fokonyv?.szocho_koltseg }} / K {{ adat.fokonyv?.szocho }} a szocho (KIVA-nál T {{ adat.fokonyv?.kiva_raforditas }} / K {{ adat.fokonyv?.kiva }}).</p>
      <p>Az ismételt feladás a korábbit felülírja (törli és újra könyveli); a kézzel rögzített tételekhez nem nyúl.</p>
    </div>
  </div>
  <div class="n-panel as-info" *ngIf="!adat.kettos">
    <ion-icon name="information-circle-outline"></ion-icon>
    <div>
      <p>A feladás egy tételt ír a kapcsolt NAPLO-ügyfél naplófőkönyvébe: a <b>4. oszlop</b> első rovatára a bruttó bért, az <b>5. oszlop</b>
        első rovatára a munkavállalói levonásokat (SZJA + TB-járulék + EKHO), és külön rovatra a munkáltatói terhet (szocho, KIVA-alanynál kisvállalati adó).
        A hiányzó rovatot a feladás hozza létre; a főkönyvi szám a NAPLO rovattörzsében állítható.</p>
      <p>Az ismételt feladás a korábbit felülírja (törli és újra könyveli). Visszavonni a NAPLO-ban, a tétel törlésével lehet.</p>
    </div>
  </div>
</ng-container>
